import {iterChildren} from '@gongxigames/framework/core/fragments/BuilderY';
import {OnAll} from '@gongxigames/framework/lib/primitives/OnAll';
import type {ActionFunction} from './Wrap';

export function Parallel(children: ActionFunction[]): ActionFunction {
    const result: ActionFunction = (instance, done) => {
        const iterator = iterChildren<ActionFunction>(children);
        const onAll = new OnAll();

        for (const child of iterator) {
            const doneCallBack = onAll.cb();

            child(instance, doneCallBack);
        }

        onAll.collect(() => done());
    };

    return result;
};
